export const BusinessPotential = {
    Unknown: 'UNKNOWN',
    Exists: 'EXISTS',
    None: 'NONE',
};

/** @type {import('types/components/acquisition').BusinessIdentificationConsumers} */
export const BusinessIdentificationConsumers = {
    LoggedInHomePage: 'logged-in-homepage',
    OrderPage: 'order',
    Listings: 'listings',
    Inbox: 'inbox',
    BuyerProfile: 'buyer-profile',
    ManageOrders: 'manage-orders',
};

/** @type {import('types/components/acquisition').BusinessInfoCollectionConsumers} */
export const BusinessInfoCollectionConsumers = {
    Listings: 'listings_page',
    LIHP: 'logged_in_home_page',
    GIG_PAGE: 'gig-page',
    SELLER_PAGE: 'seller-page'
};

/** Only from these pages we will count how many impressions there were and when was the last impression */
/** @type {Array<import('types/components/acquisition').ValueOf<BusinessIdentificationConsumers>>} */
export const recordedImpressionsPages = [
    BusinessIdentificationConsumers.LoggedInHomePage,
    BusinessIdentificationConsumers.Inbox,
];

/** We save in localStorage 3 fields:
    1. The amount of clicks on the upgrade banner
    2. The amount of impressions on the upgrade banner
    3. Last impression date on the upgrade banner
 */
export const BusinessBannerLocalStorageKeys = {
    BusinessUpgradeBannerClicksCounter: `business-upgrade-banner-c-counter`,
    BusinessUpgradeBannerImpressionsCounter: `business-upgrade-banner-i-counter`,
    BusinessUpgradeBannerImpressionsLastTime: `business-upgrade-banner-i-last-time`,
};
